// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import { X, Save } from "lucide-react";
// import "../../css/properties/propertyform.css"

// export default function SiteVisitForm({
//   visit,
//   leads,
//   properties,
//   onSubmit,
//   onCancel,
//   isLoading,
// }) {
//   const [formData, setFormData] = useState(
//     visit || {
//       lead_id: "",
//       property_id: "",
//       scheduled_date: "",
//       status: "scheduled",
//       agent_email: "",
//       feedback: "",
//       interest_rating: "",
//       notes: "",
//     }
//   );

//   useEffect(() => {
//   if (visit) {
//     setFormData({
//       lead_id: visit.lead_id || "",
//       property_id: visit.property_id || "",
//       scheduled_date: visit.scheduled_date
//         ? new Date(visit.scheduled_date).toISOString().slice(0, 16) // for datetime-local
//         : "",
//       status: visit.status || "scheduled",
//       agent_email: visit.agent_email || "",
//       interest_rating: visit.interest_rating || "",
//       feedback: visit.feedback || "",
//       notes: visit.notes || "",
//     });
//   } else {
//     setFormData({
//       lead_id: "",
//       property_id: "",
//       scheduled_date: "",
//       status: "scheduled",
//       agent_email: "",
//       interest_rating: "",
//       feedback: "",
//       notes: "",
//     });
//   }
// }, [visit]);


//   const handleSubmit = (e) => {
//     e.preventDefault();

//    const payload = {
//   ...formData,
//   interest_rating: formData.interest_rating
//     ? Number(formData.interest_rating)
//     : null,
//   scheduled_date: formData.scheduled_date
//     ? new Date(formData.scheduled_date).toISOString()
//     : null,
// };


//     onSubmit(payload);
//   };

//   return (
//     <motion.div
//       className="property-form-overlay"
//       initial={{ opacity: 0, y: -20 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit={{ opacity: 0, y: -20 }}
//     >
//       <div className="property-form-card">
//         {/* HEADER */}
//         <div className="form-header">
//           <h2>{visit ? "Edit Buyer Visit" : "Schedule Buyer Visit"}</h2>
//           <button className="icon-btn" onClick={onCancel}>
//             <X size={18} />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit}>
//           {/* LEAD & PROPERTY */}
//           <div className="grid-2">
//             <div className="form-group">
//               <label>Lead *</label>
//               <select
//                 // required
//                 value={formData.lead_id}
//                 onChange={(e) =>
//                   setFormData({ ...formData, lead_id: e.target.value })
//                 }
//               >
//                 <option value="">Select Lead</option>
//                {leads.map((lead) => (
//   <option key={lead._id} value={lead._id}>
//     {/* {lead.full_name} - {lead.phone} */}
//     {lead.full_name}
//   </option>
// ))}
                 
//               </select>
//             </div>

//             <div className="form-group">
//               <label>Property *</label>
//               <select
//                 // required
//                 value={formData.property_id}
//                 onChange={(e) =>
//                   setFormData({ ...formData, property_id: e.target.value })
//                 }
//               >
//                 <option value="">Select Property</option>
//                {properties.map((property) => (
 
//   <option key={property._id} value={property._id}>
//     {property.propertyName}
//   </option>
// ))}


//               </select>
//             </div>
//           </div>

//           {/* DATE & STATUS */}
//           <div className="grid-2">
//             <div className="form-group">
//               <label>Scheduled Date & Time *</label>
//               <input
//                 type="datetime-local"
//                 // required
//                 value={formData.scheduled_date}
//                 onChange={(e) =>
//                   setFormData({
//                     ...formData,
//                     scheduled_date: e.target.value,
//                   })
//                 }
//               />
//             </div>

//             <div className="form-group">
//               <label>Status</label>
//               <select
//                 value={formData.status}
//                 onChange={(e) =>
//                   setFormData({ ...formData, status: e.target.value })
//                 }
//               >
//                 <option value="scheduled">Scheduled</option>
//                 <option value="completed">Completed</option>
//                 <option value="cancelled">Cancelled</option>
//                 <option value="rescheduled">Rescheduled</option>
//               </select>
//             </div>
//           </div>

//           {/* AGENT & INTEREST */}
//           <div className="grid-2">
//             <div className="form-group">
//               <label>Agent Email</label>
//               <input
//                 type="email"
//                 placeholder="agent@zenrealty.com"
//                 value={formData.agent_email}
//                 onChange={(e) =>
//                   setFormData({
//                     ...formData,
//                     agent_email: e.target.value,
//                   })
//                 }
//               />
//             </div>

//             <div className="form-group">
//               <label>Interest Rating (1–5)</label>
//               <input
//                 type="number"
//                 min="1"
//                 max="5"
//                 value={formData.interest_rating}
//                 onChange={(e) =>
//                   setFormData({
//                     ...formData,
//                     interest_rating: e.target.value,
//                   })
//                 }
//               />
//             </div>
//           </div>

//           {/* FEEDBACK */}
//           <div className="form-group">
//             <label>Feedback</label>
//             <textarea
//               rows="3"
//               value={formData.feedback}
//               onChange={(e) =>
//                 setFormData({ ...formData, feedback: e.target.value })
//               }
//             />
//           </div>

//           {/* NOTES */}
//           <div className="form-group">
//             <label>Notes</label>
//             <textarea
//               rows="2"
//               value={formData.notes}
//               onChange={(e) =>
//                 setFormData({ ...formData, notes: e.target.value })
//               }
//             />
//           </div>

//           {/* FOOTER */}
//           <div className="form-footer">
//             <button type="button" onClick={onCancel} className="btn-outline">
//               Cancel
//             </button>
//             <button type="submit" disabled={isLoading} className="btn-primary">
//               <Save size={16} />
//               {isLoading ? "Saving..." : "Save Visit"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </motion.div>
//   );
// }

// Updated: 02-04-2026
// Changes:
// - Lead and Property dropdowns replaced with searchable comboboxes
// - All dropdowns have a default disabled "— Select —" placeholder
// - New "Visit Type" toggle: Agent Visit / Direct Visit
// - Agent email field shown only when "Agent Visit" is selected
// - "Notes" textarea renamed to "Feedback"
// - Old "Feedback" textarea removed (merged into single Feedback field)

import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { X, Save, Search, ChevronDown, UserCheck, Users } from "lucide-react";
import { toDateTimeLocal, fromDateTimeLocal } from "../../utils/datetime";
import "../../css/properties/propertyform.css";

/* ─────────────────────────────────────────────
   SearchableSelect — reusable combobox
───────────────────────────────────────────── */
function SearchableSelect({ label, value, onChange, options, placeholder = "— Select —", displayKey = "label", valueKey = "value" }) {
  const [open, setOpen]   = useState(false);
  const [query, setQuery] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered = options.filter((o) =>
    String(o[displayKey]).toLowerCase().includes(query.toLowerCase())
  );

  const selectedLabel = options.find((o) => o[valueKey] === value)?.[displayKey] || "";

  const handleSelect = (val) => {
    onChange(val);
    setOpen(false);
    setQuery("");
  };

  return (
    <div className="searchable-select" ref={ref}>
      <div className={`ss-trigger ${open ? "open" : ""}`} onClick={() => setOpen((p) => !p)}>
        <span className={selectedLabel ? "ss-value" : "ss-placeholder"}>
          {selectedLabel || placeholder}
        </span>
        <ChevronDown size={14} className={`ss-chevron ${open ? "rotated" : ""}`} />
      </div>

      {open && (
        <div className="ss-dropdown">
          <div className="ss-search">
            <Search size={13} />
            <input
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search..."
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <ul className="ss-list">
            {filtered.length === 0 && <li className="ss-empty">No results</li>}
            {filtered.map((o) => (
              <li
                key={o[valueKey]}
                className={`ss-item ${o[valueKey] === value ? "selected" : ""}`}
                onClick={() => handleSelect(o[valueKey])}
              >
                {o[displayKey]}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────────
   Main SiteVisitForm
───────────────────────────────────────────── */
const EMPTY_FORM = {
  lead_id:         "",
  property_id:     "",
  scheduled_date:  "",
  status:          "",
  visit_type:      "direct",   // "agent" | "direct"
  agent_email:     "",
  feedback:        "",         // shown only when status === "completed"
  remark:          "",         // shown for any other status
};

export default function SiteVisitForm({ visit, leads, properties, onSubmit, onCancel, isLoading }) {
  const [formData, setFormData] = useState(EMPTY_FORM);

  useEffect(() => {
    if (visit) {
      setFormData({
        lead_id:         typeof visit.lead_id === "object" ? visit.lead_id?._id : visit.lead_id || "",
        property_id:     typeof visit.property_id === "object" ? visit.property_id?._id : visit.property_id || "",
        scheduled_date:  toDateTimeLocal(visit.scheduled_date),
        status:          visit.status          || "",
        visit_type:      visit.visit_type      || (visit.agent_email ? "agent" : "direct"),
        agent_email:     visit.agent_email     || "",
        // Merge old notes + feedback into single feedback field
        feedback:        visit.feedback || visit.notes || "",
        remark:          visit.remark || "",
      });
    } else {
      setFormData(EMPTY_FORM);
    }
  }, [visit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const isCompleted = formData.status === "completed";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.status === "rescheduled" && !formData.scheduled_date) {
      alert("Please select the new date & time for the rescheduled visit.");
      return;
    }
    onSubmit({
      ...formData,
      scheduled_date:  fromDateTimeLocal(formData.scheduled_date),
      // Clear agent_email if direct visit
      agent_email: formData.visit_type === "agent" ? formData.agent_email : "",
      // Keep only the field relevant to the current status
      feedback: isCompleted ? formData.feedback : "",
      remark:   isCompleted ? "" : formData.remark,
    });
  };

  /* Build option arrays for searchable selects */
  const leadOptions     = leads.map((l) => ({ value: l._id, label: l.full_name + (l.phone ? ` — ${l.phone}` : "") }));
  const propertyOptions = properties.map((p) => ({ value: p._id, label: p.propertyName + (p.location ? `, ${p.location}` : "") }));

  const isAgent = formData.visit_type === "agent";

  return (
    <motion.div
      className="property-form-overlay"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      <div className="property-form-card">
        {/* HEADER */}
        <div className="form-header">
          <h2>{visit ? "Edit Buyer Visit" : "Schedule Buyer Visit"}</h2>
          <button className="icon-btn" type="button" onClick={onCancel}>
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>

          {/* LEAD & PROPERTY — searchable */}
          <div className="grid-2">
            <div className="form-group">
              <label>Lead *</label>
              <SearchableSelect
                value={formData.lead_id}
                onChange={(val) => setFormData((prev) => ({ ...prev, lead_id: val }))}
                options={leadOptions}
                placeholder="— Select Lead —"
              />
            </div>

            <div className="form-group">
              <label>Property *</label>
              <SearchableSelect
                value={formData.property_id}
                onChange={(val) => setFormData((prev) => ({ ...prev, property_id: val }))}
                options={propertyOptions}
                placeholder="— Select Property —"
              />
            </div>
          </div>

          {/* DATE & STATUS */}
          <div className="grid-2">
            <div className="form-group">
              <label>Scheduled Date & Time *</label>
              <input
                type="datetime-local"
                name="scheduled_date"
                value={formData.scheduled_date}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Status</label>
              <select name="status" value={formData.status} onChange={handleChange}>
                <option value="" disabled>— Select Status —</option>
                <option value="scheduled">Scheduled</option>
                <option value="completed">Completed</option>
                <option value="cancelled">Cancelled</option>
                <option value="rescheduled">Rescheduled</option>
              </select>
            </div>
          </div>

          {/* VISIT TYPE TOGGLE */}
          <div className="form-group">
            <label>Visit Type</label>
            <div className="visit-type-toggle">
              <button
                type="button"
                className={`toggle-btn ${formData.visit_type === "direct" ? "active" : ""}`}
                onClick={() => setFormData((prev) => ({ ...prev, visit_type: "direct", agent_email: "" }))}
              >
                <Users size={15} /> Direct Visit
              </button>
              <button
                type="button"
                className={`toggle-btn ${formData.visit_type === "agent" ? "active" : ""}`}
                onClick={() => setFormData((prev) => ({ ...prev, visit_type: "agent" }))}
              >
                <UserCheck size={15} /> Agent Visit
              </button>
            </div>
          </div>

          {/* AGENT EMAIL — only shown when Agent Visit is selected */}
          {isAgent && (
            <div className="form-group">
              <label>Agent Email *</label>
              <input
                type="email"
                name="agent_email"
                placeholder="agent@example.com"
                value={formData.agent_email}
                onChange={handleChange}
                required={isAgent}
              />
            </div>
          )}

          {/* FEEDBACK when completed, otherwise REMARK */}
          {isCompleted ? (
            <div className="form-group">
              <label>Feedback</label>
              <textarea
                rows="3"
                name="feedback"
                placeholder="Enter feedback about the completed visit..."
                value={formData.feedback}
                onChange={handleChange}
              />
            </div>
          ) : (
            <div className="form-group">
              <label>Remarks</label>
              <textarea
                rows="3"
                name="remark"
                placeholder="Enter remarks about this visit..."
                value={formData.remark}
                onChange={handleChange}
              />
            </div>
          )}

          {/* FOOTER */}
          <div className="form-footer">
            <button type="button" onClick={onCancel} className="btn-outline">Cancel</button>
            <button type="submit" disabled={isLoading} className="btn-primary">
              <Save size={16} /> {isLoading ? "Saving..." : "Save Visit"}
            </button>
          </div>

        </form>
      </div>
    </motion.div>
  );
}